module.exports = __webpack_public_path__ + "img/button_unlocked_document.2f5dd9b2.svg";